import { render, staticRenderFns } from "./MoleculePaginationSecondary.vue?vue&type=template&id=15861c34"
import script from "./MoleculePaginationSecondary.vue?vue&type=script&lang=js"
export * from "./MoleculePaginationSecondary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports